import type { JSX } from "react";

import { Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

import type { ChallengeInfo } from "@/sales-tools/challenges/api/getChallengesForEmployee";

import { useAnalytics } from "@/analytics";
import classes from "@/sales-tools/micro-learning/components/MicroLearning.module.css";
import { userCache } from "@/shared-utils";

import { AnnouncementEndContentFactory } from "./AnnouncementEndContentFactory";

export function AnnouncementEnd({ challenge }: { challenge: ChallengeInfo }): JSX.Element {
    const [opened, { close }] = useDisclosure(true);
    const { dispatcher } = useAnalytics();
    const closeModal = () => {
        void dispatcher.dispatchBusinessEvent("ChallengeAcknowledgedEnd", {
            challengeParticipantId: challenge.announcement.challengeParticipantId,
            challengeId: challenge.challengeId,
        });
        close();
    };
    const empId = userCache.employeeId;
    if (!empId) {
        return (
            <Modal opened={opened} onClose={closeModal}>
                You somehow do not have a userId
            </Modal>
        );
    }

    return (
        <Modal
            zIndex="var(--mantine-priority-highest)"
            centered
            opened={opened}
            onClose={closeModal}
            withCloseButton={false}
            padding={0}
            overlayProps={{
                backgroundOpacity: 0.4,
            }}
            classNames={{ content: classes.content }}
        >
            <AnnouncementEndContentFactory
                challengeType={challenge.challengeType}
                contentProps={{ challenge, empId, onDismiss: closeModal }}
            />
        </Modal>
    );
}
